/**
 * WURDE DIE KACHEL GERADE WIEDER EINGEBLENDET?
 *
 * Anlass (Rafael, 03.10.2026: "staendig ist der Vizekanzler nicht sichtbar"): die
 * Fremd-Coach-Spalte im Guide wird von mehreren Vorfahren per `display:none` versteckt
 * (Container-Regel unter 650 px in responsive.css, `chatSichtbar` in App.tsx, eingeklappter
 * Guide). Ein Electron-<webview> zeichnet danach nicht zuverlaessig neu — es bleibt eine
 * leere Flaeche. Die Messgroesse dafuer ist die Kachelgroesse: unter `display:none` ist sie
 * 0×0, beim Wiedereinblenden wieder > 0. Genau dieser Uebergang (und nur er) loest in
 * BrowserPanel ein Neuladen aus, wenn die Kachel `neuLadenBeimEinblenden` setzt.
 */
export interface Groesse { w: number; h: number }

export function istVersteckt(g: Groesse): boolean {
  return !(g.w > 0) || !(g.h > 0);
}

/** true genau beim Uebergang versteckt (0) → sichtbar (> 0). Erste Messung (vorher null) zaehlt nie. */
export function wurdeWiederEingeblendet(vorher: Groesse | null, jetzt: Groesse): boolean {
  return vorher !== null && istVersteckt(vorher) && !istVersteckt(jetzt);
}
